import { Icons } from '@/assets/icons/icons';
import { ModalsManager } from '@/components/modals/modalsManager';
import { Button } from '@/components/ui/Button';
import { FeedbackModal } from '@/features/feedback/feedback';

export const RegenerateButton = ({
  onPress,
  error,
}: {
  error?: string;
  onPress: () => void;
}) => {
  return (
    <div className={'flex gap-3 items-center'}>
      <div className="normal-case px-3 rounded-md cursor-pointer flex items-center justify-center text-xs font-mono whitespace-nowrap w-full">
        <div className="flex">
          <div className="flex flex-col items-center gap-2">
            {error ?? 'There was an error generating a response'}
            <div className="flex flex-row items-center gap-2">
              <Button
                variant="outline"
                className="text-xs gap-2"
                onClick={() => {
                  onPress();
                }}
              >
                <Icons.refresh className="w-4 h-4" /> Try again
              </Button>
              <Button
                variant="outline"
                className="text-xs gap-2"
                onClick={() => ModalsManager.show(FeedbackModal, {})}
              >
                <Icons.feedback className="w-4 h-4" /> Submit feedback
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
